<template>
    <el-card v-loading="loading">
        <template slot="header">
            编辑分类
        </template>
        <el-form :model="Cate"
                 :rules="rules"
                 ref="ruleForm"
                 label-position="right"
                 label-width="160px">

            <el-form-item label="上级分类" prop="parent_id" v-if="Cate.parent_id!==0 || Cate.low_cate == 0 ">
                <el-select v-model="Cate.parent_id" placeholder="请选择">
                    <el-option key="0" label="顶级分类" value="0" v-bind:value="0"></el-option>
                    <el-option
                            v-for="item in cateParent"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="分类名称" prop="name">
                <el-input v-model="Cate.name"></el-input>
            </el-form-item>

            <el-form-item label="是否列表\详情右侧展示" prop="is_show_right">
                <el-radio-group v-model="Cate.is_show_right">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input-number v-model="Cate.sort" :min="0" :max="999"  :step="1"></el-input-number>
            </el-form-item>
            <!--<el-form-item label="跳转类型" prop="jump_type">-->
                <!--<el-radio v-model="cate.jump_type" label="1">列表</el-radio>-->
                <!--<el-radio v-model="cate.jump_type" label="2">URL</el-radio>-->
            <!--</el-form-item>-->

            <!--<el-form-item label="跳转地址" prop="jump_url" v-if="cate.jump_type == 2">-->
                <!--<el-input v-model="Cate.jump_url"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item>
                <el-button type="primary" @click="update('ruleForm')">保存</el-button>
                <el-button type="success" @click="back">返回</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
    import {mapState} from 'vuex'
    import '@/static/test'

    export default {
        name: "CateEdit",
        props: {
            id: {
                required: true,
            }
        },
        components: {},
        computed: {
            ...mapState({
                cateParent: state => state.cate.cateParent,
                Cate: state => state.cate.Cate,
                rules: state => state.cate.rules,
                loading: state => state.cate.loading
            })
        },
        methods: {
            back() {
                this.$router.back();
            },
            update(form) {
                let vthis = this;
                this.$refs[form].validate((validate) => {
                    if (!validate) {
                        return;
                    }
                    this.$store.dispatch('cate/update').then(res => {
                    vthis.$confirm('是否关闭页面?')
                        .then(_ => {
                            vthis.$router.back();
                        });
                    })
                    .catch(res => {
                        console.log(res);
                    });
                });

            }
        },
        created() {
            this.$store.dispatch('cate/show', {id: this.id});
            this.$store.dispatch('cate/getPrent');
            let vthis = this;
        },
        data() {
            return {
                cate: {}
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/cate/CateEdit.vue